export const FIRM_DOCUMENTS_TEST_IDS = {
  bulkActionsAnalyzeCapTable: 'firm-documents-bulk-actions-analyze-cap-table',
  bulkActionsAnalyzeFinancials: 'firm-documents-bulk-actions-analyze-financials',
  bulkActionsCopy: 'firm-documents-bulk-actions-copy',
  bulkActionsDelete: 'firm-documents-bulk-actions-delete',
  bulkActionsDownload: 'firm-documents-bulk-actions-download',
  bulkActionsMenu: 'firm-documents-bulk-actions-menu',
  bulkActionsTrigger: 'firm-documents-bulk-actions-trigger',
  centerPane: 'firm-documents-center-pane',
  companyPane: 'firm-documents-company-pane',
  documentSearchInput: 'firm-documents-document-search-input',
  filterApplyButton: 'firm-documents-filter-apply-button',
  filterButton: 'firm-documents-filter-button',
  filterDialog: 'firm-documents-filter-dialog',
  filterFileTypeOption: (value: string) => `firm-documents-filter-file-type-${value}`,
  filterReferenceTypeOption: (value: string) => `firm-documents-filter-reference-type-${value}`,
  filterResetButton: 'firm-documents-filter-reset-button',
  filterSortOption: (value: string) => `firm-documents-filter-sort-${value}`,
  filterSourceMenu: 'firm-documents-filter-source-menu',
  filterSourceOption: (value: string) => `firm-documents-filter-source-${value}`,
  filterSourceSearchInput: 'firm-documents-filter-source-search-input',
  filterSourceSelect: 'firm-documents-filter-source-select',
  fullscreenButton: 'firm-documents-fullscreen-button',
  leftResizeHandle: 'firm-documents-left-resize-handle',
  root: 'firm-documents-page',
  selectAllDocuments: 'firm-documents-select-all-documents',
  workspaceLayout: 'firm-documents-workspace-layout',
} as const;
